import type { LucideIcon } from "lucide-react";
import { ArrowUpRight, TrendingUp } from "lucide-react";

interface MetricCardProps {
    title: string;
    value: number | string | null;
    icon: LucideIcon;
    subtitle?: string;
    trend?: string;
    trendColor?: string;
    accent?: boolean;
    onClick?: () => void;
}

const MetricCard = ({
    title,
    value,
    icon: Icon,
    subtitle,
    trend,
    trendColor = "text-gray-400",
    accent = false,
    onClick,
}: MetricCardProps) => (
    <div
        onClick={onClick}
        className={`relative rounded-2xl p-5 flex flex-col gap-3 overflow-hidden transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 cursor-pointer ${accent
            ? "bg-[#1a7a4a] text-white shadow-md shadow-[#1a7a4a]/20"
            : "bg-white border border-gray-100 shadow-sm"
            }`}
    >
        {/* Top row: icon + arrow */}
        <div className="flex items-center justify-between">
            <div
                className={`p-2 rounded-xl ${accent ? "bg-white/20" : "bg-[#e8f5ee]"
                    }`}
            >
                <Icon
                    className={`h-4 w-4 ${accent ? "text-white" : "text-[#1a7a4a]"}`}
                />
            </div>
            <div
                className={`p-1.5 rounded-full border ${accent
                    ? "border-white/30 text-white"
                    : "border-gray-200 text-gray-400"
                    }`}
            >
                <ArrowUpRight className="h-3 w-3" />
            </div>
        </div>

        {/* Value */}
        <div
            className={`text-3xl font-bold tracking-tight ${accent ? "text-white" : "text-gray-900"
                }`}
        >
            {value ?? "—"}
        </div>

        {/* Title + subtitle */}
        <div>
            <div
                className={`text-sm font-semibold ${accent ? "text-white" : "text-gray-700"
                    }`}
            >
                {title}
            </div>
            {(subtitle || trend) && (
                <div
                    className={`text-xs mt-0.5 flex items-center gap-1 ${accent ? "text-white/70" : trendColor
                        }`}
                >
                    {trend && <TrendingUp className="h-3 w-3" />}
                    {trend && <span>{trend}</span>}
                    {subtitle && <span>{subtitle}</span>}
                </div>
            )}
        </div>
    </div>
);

export default MetricCard;
